import { ElNotification, ElMessage } from 'element-plus'
import i18n from '@/i18n'
import loading from '@/components/common/loading'

export const $notification = ElNotification
export const $messages = ElMessage
export const $t = i18n.global.t
export const $loading = loading

// 防抖函数：防止短时间内多次调用同一个函数
export const debounce = (func: Function, delay: number = 1000) => {
    let timeoutId: any = null
    return (...args: any[]) => {
        clearTimeout(timeoutId)
        timeoutId = setTimeout(() => func.apply(this, args), delay)
    }
}

/**
 * 判断字符串是否为图片地址
 * @param {string} url 需要判断的字符串
 * @returns {boolean} 是否为图片地址
 */
export const isImageByUrl = (url: string): boolean => {
    if (!url || typeof url !== 'string') {
        return false
    }

    // 判断是否为base64图片
    if (url.startsWith('data:image/')) {
        return true
    }

    // 判断是否为网络图片
    if (url.startsWith('http://') || url.startsWith('https://')) {
        // 检查文件扩展名
        const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.bmp']
        return imageExtensions.some(ext => url.toLowerCase().endsWith(ext))
    }

    // 判断是否为本地图片路径
    if (url.startsWith('/') || url.startsWith('./') || url.startsWith('../')) {
        const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.bmp']
        return imageExtensions.some(ext => url.toLowerCase().endsWith(ext))
    }

    return false
}

export const isLocal = () => {
    return location.hostname == 'localhost' || location.hostname == '127.0.0.1'
}

export const sleep = (ms: number = 500) => {
    return new Promise(resolve => setTimeout(resolve, ms))
}

export const parseUrlParams = (url = window.location.href) => {
    const params: Record<string, string> = {}

    // 提取查询字符串部分
    const queryString = url.includes('?') ? url.split('?')[1] : url

    if (!queryString) return params

    // 移除可能的hash部分
    const cleanQuery = queryString.split('#')[0]

    // 分割参数
    const pairs = cleanQuery.split('&')

    pairs.forEach(pair => {
        const [key, value] = pair.split('=')
        if (key) {
            params[decodeURIComponent(key)] = value ? decodeURIComponent(value) : ''
        }
    })

    return params
}
